import React, { useState } from 'react';
import Tabs from '../../../../../components/Tabs';
import CsReviewCreateNavbar from '../CsReviewCreateNavbar';
import CsReviewCreateForm from '../CsReviewCreateForm';
import CsReviewTagInfo from '../../../common/review/CsReviewTagInfo';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import useCreateForm from '../../common/hook/queries/useCreateFormQuery';
import { yupResolver } from '@hookform/resolvers/yup';
import { reviewCreateFormValidationSchema } from '../../common/util/reviewFormValidate';
import { PRODUCT_LIST_SEARCH_KEYWORD_TYPE } from '../../../../../constants/service/app/productConstants';
import { USER_LIST_SEARCH_KEYWORD_TYPE } from '../../../../../constants/service/app/userConstants';
import { REVIEW_FORM_TAB_KEY } from '../../common/constants';
import { REVIEW_CRITERIA_DEFAULT } from '../../../../../constants/service/app/csReviewConstants';

import './CsReviewCreateWrap.scss';

const CsReviewCreateWrap = () => {
  const [currentTabKey, setCurrentTabKey] = useState(REVIEW_FORM_TAB_KEY.REVIEW);

  const methods = useForm({
    resolver: yupResolver(reviewCreateFormValidationSchema),
    defaultValues: {
      productSearchType: PRODUCT_LIST_SEARCH_KEYWORD_TYPE.PRODUCT_NAME,
      userSearchType: USER_LIST_SEARCH_KEYWORD_TYPE.USER_ID,
      reviewCriteria: REVIEW_CRITERIA_DEFAULT,
      imgUrls: [],
      tagIds: [],
    },
  });

  const { handleSubmit, watch } = methods;
  const { mutate: createReview, isLoading } = useCreateForm();
  const reviewCriteria = watch('reviewCriteria');
  const product = watch('selectedProduct');
  const imgUrls = watch('imgUrls');

  const onSubmit = (data) => {
    const { content, selectedUser, rate } = data;
    // 더블 클릭 방지
    if (!isLoading) {
      const reviewContents = {
        productId: product?.id,
        userId: selectedUser?.id,
        rate,
        content,
        imgUrls,
        tagIds: data.tagIds.map((tag) => tag.id),
        reviewCriteria,
      };
      createReview(reviewContents);
    }
  };
  const checkKeyDown = (e) => {
    if (e.key === 'Enter' && e.target.tagName === 'INPUT') {
      e.preventDefault();
    }
  };

  return (
    <div className="cs-review-create-wrap">
      <FormProvider {...methods}>
        <form id="create-review-form" onSubmit={handleSubmit(onSubmit)} onKeyDown={checkKeyDown}>
          {/* 하단 네브바 */}
          <CsReviewCreateNavbar />
          <Tabs
            className="review-create-tabs"
            activeKey={currentTabKey}
            onChange={(tabKey) => setCurrentTabKey(tabKey)}
            list={[
              {
                title: '상품 후기 정보',
                content: <CsReviewCreateForm />,
              },
              {
                title: '태그 정보',
                content: (
                  <Controller
                    name="tagIds"
                    control={methods.control}
                    render={({ field: { onChange, value } }) => (
                      <CsReviewTagInfo name="tagIds" productId={product?.id} onChange={onChange} value={value} />
                    )}
                  />
                ),
              },
            ]}
          />
        </form>
      </FormProvider>
    </div>
  );
};

export default CsReviewCreateWrap;
